import { combineReducers } from 'redux'
import addPartDialog from './addPartDialog'
import addPackDialog from './addPackDialog'
import movePartsDialog from './movePartsDialog'
import parts from './parts'
import importReducer from './import'
import part from './part'
import addPriceListDialog from "./addPriceListDialog"
import Immutable from 'seamless-immutable'
import types from '../../actions/types'
import partCategoryTreeSelectField from './partCategoryTreeSelectField'
import {types as PriceListTypes} from '../../actions/priceLists'
import nonPrefixedTypes from 'actions/types'

const partImageDates = (state = Immutable({default: new Date().getTime()}), action) => {
  switch (action.type) {
    case types.PRICE_LISTS_PART_UPLOAD_IMAGE_SUCCESS:
    case types.PRICE_LISTS_PART_REMOVE_IMAGE_SUCCESS: {
      return {
        ...state,
        [action.partId]: new Date().getTime(),
      }
    }
    default:
      return state
  }
}

export const expandedCategories = (state = [], action) => {
  switch (action.type) {
    case nonPrefixedTypes.PRICE_LISTS_PART_CATEGORY_MOVE_ATTEMPT:
      return [...state, action.moveDestinationCategoryId]
    case PriceListTypes.PRICE_LIST_EXPAND_CATEGORY:
      return [...state, action.categoryId]
    case PriceListTypes.PRICE_LIST_COLLAPSE_CATEGORY:
      return state.filter(c => c !== action.categoryId)
    case types.PRICE_LISTS_PART_CATEGORY_ADD_SUCCESS:
      return state.includes(action.data.result.parentId) ? state : [...state, action.data.result.parentId]
    default:
      return state
  }
}

export const partCategoryDetailsExpanded = (state = true, action) => {
  switch (action.type) {
    case PriceListTypes.PRICE_LIST_TOGGLE_CATEGORY_DETAILS:
      return action.isPartCategoryDetailsExpanded
    default:
      return state
  }
}

export const suppliersOpen = (state = false, action) => {
  switch (action.type) {
    case PriceListTypes.PRICE_LIST_TOGGLE_SUPPLIERS:
      return action.isSuppliersOpen
    default:
      return state
  }
}

export default combineReducers({
  addPartDialog,
  addPackDialog,
  addPriceListDialog,
  movePartsDialog,
  parts,
  partImageDates,
  expandedCategories,
  part,
  'import': importReducer,
  partCategoryTreeSelectField,
  partCategoryDetailsExpanded,
  suppliersOpen,
})
